import { Box, Typography } from '@mui/material';
import {
  Button,
  FlexContainer,
  FormBuilder,
  IconLibrary,
  ReemaThemeV2,
} from '@act/storybook';
import { Control, FormState, UseFormReset } from 'react-hook-form';
import { CallCreationRequestForm } from '@act/shared/data-transfer-objects';
import { FormConfig } from 'stories/forms/FormBuilder/formBuilder.types';

interface CallFormContentProps {
  control: Control<CallCreationRequestForm>;
  formState: FormState<CallCreationRequestForm>;
  formConfig: FormConfig<CallCreationRequestForm>;
  isResourceCall: boolean;
  reset: UseFormReset<CallCreationRequestForm>;
  onToggleResourceCall: () => void;
  memberName: string;
}

export const CallFormContent = ({
  memberName,
  control,
  formState,
  formConfig,
  isResourceCall,
  reset,
  onToggleResourceCall,
}: CallFormContentProps) => {
  return (
    <FlexContainer
      direction="column"
      alignItems="flex-start"
      justifyContent="center"
      gap={2}
      padding={6}
      width="100%"
      height="80%"
    >
      <Box
        sx={{
          borderBottom: `1px solid ${ReemaThemeV2.LIGHT_MODE.palette.greyShades[250]}`,
        }}
      >
        <Typography
          variant="headlineMedium"
          color="text.primary"
          paddingBottom={4}
        >
          {isResourceCall
            ? `Call a resource for ${memberName}`
            : `Select a number for ${memberName}`}
        </Typography>
      </Box>

      <FormBuilder
        control={control}
        formState={formState}
        config={formConfig}
      />
      <Box sx={{ display: 'flex', gap: '16px' }}>
        <Button
          variant="text"
          startIcon={
            !isResourceCall ? (
              <IconLibrary
                iconName="ListMagnifyingGlass"
                size={32}
                weight="regular"
              />
            ) : undefined
          }
          onClick={() => {
            reset();
            onToggleResourceCall();
          }}
          sx={{
            backgroundColor: 'neutralLight.main',
          }}
        >
          <Typography variant="labelLarge" color="text.secondary">
            {!isResourceCall ? 'Resource Call' : 'Cancel'}
          </Typography>
        </Button>
      </Box>
    </FlexContainer>
  );
};
